module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/bvPldq/tc-custom/9781569752777.jpg?1702409234587",
      "alt": "This image is the cover for the book Courage After Fire"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Courage After Fire\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The bravery displayed by our soldiers at war is commonly recognized. However, often forgotten is the courage required by veterans when they return home and suddenly face reintegration into their families, workplaces, and communities. Authored by three mental health professionals with many years of experience counseling veterans, "), _c('i', [_vm._v("Courage After Fire")]), _vm._v(" provides strategies and techniques for this challenging journey home."), _c('br'), _c('br'), _c('i', [_vm._v("Courage After Fire ")]), _vm._v("offers soldiers and their families a comprehensive guide to dealing with the all-too-common repercussions of combat duty, including posttraumatic stress symptoms, anxiety, depression, and substance abuse. It details state-of-the-art treatments for these difficulties and outlines specific ways to improve couple and family relationships. It also offers tips on areas such as rejoining the workforce and reconnecting with children."), _c('br'), _c('br'), _vm._v(" “A crucial tool for the men and women who have been serving our country so VALIANTLY during these past years.” —Senator Bob Dole, from the foreword"), _c('br'), _c('br'), _vm._v(" “This extraordinary work will help the men and women returning from Iraq and Afghanistan find the COURAGE to rebuild their lives and be successful.” —Honorable Anthony J. Principi, Former Secretary of Veterans Affairs ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Keith Armstrong, Suzanne Best, Paula Domenici, Bob Doyle\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Perseus\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0